import { render, staticRenderFns } from "./collections.vue?vue&type=template&id=2ab0b07b&scoped=true"
import script from "./collections.vue?vue&type=script&lang=js"
export * from "./collections.vue?vue&type=script&lang=js"
import style0 from "./collections.vue?vue&type=style&index=0&id=2ab0b07b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab0b07b",
  null
  
)

export default component.exports